export default [
  {
    path: '/meditation',
    component: () => import(/* webpackChunkName: "meditation" */ '@/views/Meditation/pages'),
    children: [
      {
        path: '/',
        name: 'Meditation',
        component: () => import(/* webpackChunkName: "meditation" */ '@/views/Meditation/pages/Meditation'),
      },
      {
        path: 'list-categories',
        name: 'ListMeditationCategories',
        component: () => import(/* webpackChunkName: "meditation" */ '@/views/Meditation/pages/ListCategories')
      },
      {
        path: 'list-plans',
        name: 'ListMeditations',
        component: () => import(/* webpackChunkName: "meditation" */ '@/views/Meditation/pages/ListMeditations')
      },
      {
        path: 'register',
        name: 'RegisterMeditation',
        component: () => import(/* webpackChunkName: "meditation" */ '@/views/Meditation/pages/RegisterMeditation')
      },
      {
        path: ':id/edit',
        name: 'EditMeditation',
        component: () => import(/* webpackChunkName: "meditation" */ '@/views/Meditation/pages/RegisterMeditation')
      },
      {
        path: 'register-narration',
        name: 'RegisterNarration',
        component: () => import(/* webpackChunkName: "meditation" */ '@/views/Meditation/pages/RegisterNarration')
      },
      {
        path: ':id/edit',
        name: 'EditNarration',
        component: () => import(/* webpackChunkName: "meditation" */ '@/views/Meditation/pages/RegisterNarration')
      },
      {
        path: 'list-narrations',
        name: 'ListNarrations',
        component: () => import(/* webpackChunkName: "meditation" */ '@/views/Meditation/pages/ListNarrations')
      },
      {
        path: 'register-music',
        name: 'RegisterMusic',
        component: () => import(/* webpackChunkName: "meditation" */ '@/views/Meditation/pages/RegisterMusic')
      },
      {
        path: ':id/edit',
        name: 'EditMusic',
        component: () => import(/* webpackChunkName: "meditation" */ '@/views/Meditation/pages/RegisterMusic')
      },
      {
        path: 'list-musics',
        name: 'ListMusics',
        component: () => import(/* webpackChunkName: "meditation" */ '@/views/Meditation/pages/ListMusics')
      },
      {
        path: ':id/tasks',
        component: () => import(/* webpackChunkName: "meditation-tasks" */ '@/views/Meditation/pages/Tasks'),
        children: [
          {
            path: '/',
            name: 'MeditationTasks',
            component: () => import(/* webpackChunkName: "meditation-tasks" */ '@/views/Meditation/pages/Tasks/pages/Task'),
          },
          {
            path: 'register',
            name: 'MeditationRegisterTask',
            component: () => import(/* webpackChunkName: "meditation-tasks" */ '@/views/Meditation/pages/Tasks/pages/RegisterTask')
          },
          {
            path: ':idTask/edit',
            name: 'MeditationEditTask',
            component: () => import(/* webpackChunkName: "meditation-tasks" */ '@/views/Meditation/pages/Tasks/pages/RegisterTask')
          },
        ]
      },
    ],
  },
]
